/**
 * Google OAuth Provider Component
 *
 * Wraps the application with Google OAuth context.
 * Only enables Google OAuth if the required environment variable is set.
 *
 * Epic: E1.7 - Google OAuth Social Login Integration
 */

import { FC, ReactNode } from 'react'
import { GoogleOAuthProvider as GoogleOAuthProviderBase } from '@react-oauth/google'
import { GOOGLE_CLIENT_ID } from './googleOAuthConfig'

interface GoogleOAuthProviderProps {
  children: ReactNode
}

/**
 * Google OAuth Provider Component
 *
 * Conditionally wraps children with GoogleOAuthProvider if configured.
 * Falls back to just rendering children if Google OAuth is not enabled.
 */
export const GoogleOAuthProvider: FC<GoogleOAuthProviderProps> = ({ children }) => {
  // If Google OAuth is not configured, just render children
  if (!GOOGLE_CLIENT_ID) {
    return <>{children}</>
  }

  return (
    <GoogleOAuthProviderBase clientId={GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProviderBase>
  )
}
